import { Location, AsyncPipe } from '@angular/common';
import { AfterContentChecked, ChangeDetectionStrategy, Component } from '@angular/core';
import { EventService, TranslationService, WindowRef } from '@spartacus/core';
import { CurrentProductService, ProductDetailOutlets, ProductIntroComponent, OutletDirective } from '@spartacus/storefront';

@Component({
    selector: 'kn-br-product-intro',
    templateUrl: './kn-br-product-intro.component.html',
    styleUrls: ['./kn-br-product-intro.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [OutletDirective, AsyncPipe]
})
export class KnBrProductIntroComponent extends ProductIntroComponent implements AfterContentChecked {
  outlets = ProductDetailOutlets;
    isMaterialOverviewExpanded = false;
  private readonly materialOverviewThreshold = 700; // Number of characters to display before truncating
  constructor(
    protected currentProductService: CurrentProductService,
    protected knBrTranslationService: TranslationService,
    protected winRef: WindowRef,
    protected location: Location,
    protected eventService: EventService
  ) {
    super(currentProductService, knBrTranslationService, winRef, eventService);
  }
  ngAfterContentChecked() {
    // super.ngAfterContentChecked(); Need to Discuss
  }

  
  toggleMaterialOverview(event: Event): void {
    event.preventDefault();
    this.isMaterialOverviewExpanded = !this.isMaterialOverviewExpanded;
  }

  isLongMaterialOverview(materialOverviewText?: string | null): boolean {
    return this.getPlainMaterialOverviewText(materialOverviewText).length > this.materialOverviewThreshold;
  }

  getDisplayedMaterialOverviewText(materialOverviewText?: string | null): string {
    const plainText = this.getPlainMaterialOverviewText(materialOverviewText);

    if (!this.isMaterialOverviewExpanded && plainText.length > this.materialOverviewThreshold) {
      return `${plainText.slice(0, this.materialOverviewThreshold).trimEnd()}...`;
    }

    return plainText;
  }

  private getPlainMaterialOverviewText(materialOverviewText?: string | null): string {
    if (!materialOverviewText) {
      return '';
    }

    // Convert HTML-rich content into visible text before truncating.
    return materialOverviewText.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  }

  back() {
    this.location.back();
  }
}
